import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ChamadoTipoService extends BaseService {
  constructor() {
    super(`${ConfigApi.chamadoTipoURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.login = '';
    this.nome = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new ChamadoTipoService();
